import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { customer } from '../model/customer';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserSignUpService {

  constructor(private http:HttpClient) { }



  login(cus: customer):Observable<customer>{

  return  this.http.post<customer>("https://house-books1.herokuapp.com/book/getUser",cus)
  }
  signup(cus: customer):Observable<customer>{
    
  return  this.http.post<customer>("https://house-books1.herokuapp.com/book/customers",cus)
  }
}
